import { WarningOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { useActionHackerRefine } from "hook/default/hacker/useActionHacker";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffHacker = () => {
  // -------------------------- VAR -----------------------------
  const { total } = useActionHackerRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (total === 0) return null;
  return (
    <Row className="w-full" align={"center"}>
      <Col xl={14} lg={14} md={24} xs={24}>
        <div className="flex min-h-[60px] flex-row gap-5 rounded-md border-[1px] border-red-700 bg-red-50 p-[24px]">
          <div>
            <WarningOutlined
              style={{ fontSize: 36, marginTop: 10, color: "black" }}
            />
          </div>
          <div className="flex flex-col gap-1">
            <Typography.Text
              className="text-red-700"
              style={{ fontWeight: 500, fontSize: 24 }}
            >
              Cảnh báo chống gian lận
            </Typography.Text>
            <Typography.Text className="text-[16px]">
              Bạn vừa tải lên các tệp đã cố ý thay đổi đuôi định dạng không
              trùng khớp với nguyên bản. Xin vui lòng không lặp lại hành động
              này ! Nếu tiếp tục thì hệ thống sẽ vĩnh viễn thu hồi tài khoản của
              bạn. Nếu có bất kỳ câu hỏi nào về cảnh báo này, xin vui lòng liên
              hệ Admin để hỗ trợ xử lý. Xin cám ơn
            </Typography.Text>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default BailiffHacker;
